document.addEventListener('DOMContentLoaded', () => {
	// Empire with "Category Breadcrumbs" App Specific -
	// Replace initial underscore on breadcrumbs to match tag format
	document.querySelectorAll('span.breadcrumb__tags').forEach(x =>
		x.innerHTML = x.innerHTML.split(' + ').map(tag => tag.replace(/_/, ' - ')).join(' + ')
	);
});